export let dataProps = {
    id: 0,
    leave_name: '',
    maximum_paid_leave_allowed: 0,
    how_many_allowed_at_a_time: 1,
    must_apply_before_x_number_of_days: 1,
    pay_cut_percent: 0,
    extra_pay_percent: 0,
    allowed_per_month: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveMaster/properties.js